import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Switch from 'shopper/components/Switch';

const SwitchGroup = ({ title, switches, verifyChecked, onToggle }) => (
  <div key={title} className="flex flex-col gap-y-4 md:gap-y-3">
    <Heading
      as="h3"
      className="mb-2 text-neutral-low-100 dark:text-neutral-high-200 md:mb-2"
      size="size6"
    >
      {title}
    </Heading>
    {switches.map(({ id, label }) => (
      <Switch
        key={id}
        checked={verifyChecked(id)}
        label={label}
        name={id}
        onChange={onToggle}
      />
    ))}
  </div>
);

SwitchGroup.propTypes = {
  title: PropTypes.string.isRequired,
  switches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  verifyChecked: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SwitchGroup;
